/**
 * This can be used like a Fragment in React. https://legacy.reactjs.org/docs/fragments.html
 */
export default (_props, children) => [...children];
